import { isMobile, isTablet } from "mobile-device-detect";

export default function useCompany() {
  console.log("isTablet=>", isTablet);
  return {
    provider: process.env.VUE_APP_SERVICE_COMPANY,
    name: process.env.VUE_APP_SERVICE_COMPANY_NAME,
    url: process.env.VUE_APP_SERVICE_COMPANY_URL,
    icon:
      isMobile || isTablet
        ? `/images/${process.env.VUE_APP_SERVICE_COMPANY_ICON}`
        : `/images/${process.env.VUE_APP_SERVICE_COMPANY_ICON}`,
    title: process.env.VUE_APP_TITLE,
  };
}
